import React from 'react';
import { Button, Card, Space, Table, TableColumnsType, Tag, Typography } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { formatDateTime, textNumberFormater } from '../../../../utils';

const { Text } = Typography;

interface BillDetailPaymentsCardProps {
  payments: any[];
  balanceDue: number;
  paymentOptions: any[];
  onOpenPaymentModal: () => void;
}

export const BillDetailPaymentsCard: React.FC<BillDetailPaymentsCardProps> = ({
  payments,
  balanceDue,
  paymentOptions,
  onOpenPaymentModal
}) => {
  const columnsPayments: TableColumnsType = [
    {
      title: "Fecha de Pago (Efectiva)",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (d: string, record: any) => {
        const val = d || record.created_at;
        return val ? formatDateTime(val) : "-";
      },
    },
    {
      title: "Fecha Registro (Sistema)",
      dataIndex: "created_at",
      key: "created_at",
      render: (d: string) => (d ? formatDateTime(d) : "-"),
    },
    {
      title: "Medio de Pago",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (method: string) => {
        const opt = paymentOptions.find(o => o.key === method);
        return <Tag color="gold">{opt?.string_value || method || "Efectivo"}</Tag>;
      },
    },
    {
      title: "Soporte / Comprobante",
      dataIndex: "reference",
      key: "reference",
      render: (ref: string) => ref || "-",
    },
    {
      title: "Notas",
      dataIndex: "notes",
      key: "notes",
      render: (notes: string) => notes || "-",
    },
    {
      title: "Monto",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (val: number) => (
        <Text strong style={{ color: "#52c41a" }}>
          {textNumberFormater(Number(val) || 0)}
        </Text>
      ),
    },
  ];

  return (
    <Card
      title={
        <Space>
          <DollarOutlined style={{ color: "#52c41a" }} />
          <span>Historial de Pagos / Abonos Registrados</span>
          {payments && payments.length > 0 && (
            <Tag color="blue">{payments.length}</Tag>
          )}
        </Space>
      }
      extra={
        balanceDue > 0 && (
          <Button 
            size="small" 
            type="primary" 
            icon={<DollarOutlined />} 
            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            onClick={onOpenPaymentModal}
          >
            Registrar Abono
          </Button>
        )
      }
      style={{ marginTop: 24 }}
      className="card-shadow"
    >
      <Table
        columns={columnsPayments}
        dataSource={payments || []}
        pagination={false}
        size="small"
        rowKey={(rec: any, idx?: number) => String(rec.uid || rec.id || `payment-${idx}`)}
        locale={{ emptyText: 'No hay abonos registrados para esta factura' }}
        scroll={{ x: 600 }}
      />
    </Card>
  );
};
